'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002425 from "./presto.-Agent-View$$anon$25.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002427 from "./presto.-Agent-View$$anon$27.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dFile$002dBase64$002dRequest$0024 from "./presto.-Agent-View$-Local-Pje-Office-Sign-File-Base64-Request$.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$24() {
  this.axN = null;
  this.axF = null;
  this.axG = false;
  this.axO = null;
  this.axP = false;
  this.axS = null;
  this.axL = null;
  this.axM = false;
  this.axH = null;
  this.axI = false;
  this.axJ = null;
  this.axK = false;
  this.axQ = false;
  this.axR = false;
  this.axN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.axS = "LocalPjeOfficeSignFileBase64Request";
}
export { $c_Lpresto_AgentView$$anon$24 as $c_Lpresto_AgentView$$anon$24 };
$p = $c_Lpresto_AgentView$$anon$24.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$24;
/** @constructor */
function $h_Lpresto_AgentView$$anon$24() {
}
export { $h_Lpresto_AgentView$$anon$24 as $h_Lpresto_AgentView$$anon$24 };
$h_Lpresto_AgentView$$anon$24.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.axN;
});
$p.L = (function() {
  if ((!this.axG)) {
    this.axF = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.axG = true;
  }
  return this.axF;
});
$p.O = (function() {
  if ((!this.axP)) {
    this.axO = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.axP = true;
  }
  return this.axO;
});
$p.E = (function() {
  return this.axS;
});
$p.t = (function() {
  if ((!this.axM)) {
    this.axL = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("algo", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("files", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.axM = true;
  }
  return this.axL;
});
$p.M = (function() {
  if ((!this.axI)) {
    this.axH = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().fd(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002425.$c_Lpresto_AgentView$$anon$25())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.axI = true;
  }
  return this.axH;
});
$p.Q = (function() {
  if ((!this.axK)) {
    this.axJ = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002427.$c_Lpresto_AgentView$$anon$27();
    this.axK = true;
  }
  return this.axJ;
});
$p.w = (function() {
  if ((!this.axR)) {
    this.axQ = false;
    this.axR = true;
  }
  return this.axQ;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee180) => ((p) => \u03b4scrutinee180.cFN(p)))($j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dFile$002dBase64$002dRequest$0024.$m_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request$())));
});
var $d_Lpresto_AgentView$$anon$24 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$24, "presto.AgentView$$anon$24", ({
  DN: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$24 as $d_Lpresto_AgentView$$anon$24 };
//# sourceMappingURL=presto.-Agent-View$$anon$24.js.map
